import React, { useState } from "react";
import { FieldDefinition } from "../../../types/formMaps";
import PlainTextDisplay from "./PlainTextDisplay";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

interface SummaryTabAccordionProps {
  title: string;
  items: FieldDefinition[];
  values: any;
}

const SummaryTabAccordion: React.FC<SummaryTabAccordionProps> = ({
  title,
  items,
  values,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="bg-white p-4">
      <div
        className="flex justify-between items-center cursor-pointer border-b-2 border-gray-300 pb-2 mb-3"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <span className="text-gray-500">
          {isOpen ? (
            <FiChevronUp className="font-bold text-gray-700" />
          ) : (
            <FiChevronDown className="font-bold text-gray-700" />
          )}
        </span>
      </div>

      {isOpen && (
        <table className="w-full mt-2 border-collapse table-fixed">
          <colgroup>
            <col style={{ width: "33%" }} />
            <col style={{ width: "67%" }} />
          </colgroup>
          <tbody>
            {items.map((item, index) => (
              <tr key={index} className="h-12">
                <td className="p-3 text-sm font-bold text-gray-700">
                  {item.label}
                </td>
                <td className="p-3 text-sm text-gray-900">
                  <PlainTextDisplay
                    value={values.data[item.name]}
                    fieldType={item.type}
                    rightAlignCurrency={false}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SummaryTabAccordion;
